var W = Object.create;
var I = Object.defineProperty;
var X = Object.getOwnPropertyDescriptor;
var T = (i, t) => (t = Symbol[i]) ? t : Symbol.for("Symbol." + i), d = (i) => {
  throw TypeError(i);
};
var q = (i, t, e) => t in i ? I(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var B = (i, t) => I(i, "name", { value: t, configurable: !0 });
var m = (i) => [, , , W((i == null ? void 0 : i[T("metadata")]) ?? null)], D = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], f = (i) => i !== void 0 && typeof i != "function" ? d("Function expected") : i, Y = (i, t, e, o, n) => ({ kind: D[i], name: t, metadata: o, addInitializer: (r) => e._ ? d("Already initialized") : n.push(f(r || null)) }), P = (i, t) => q(t, T("metadata"), i[3]), w = (i, t, e, o) => {
  for (var n = 0, r = i[t >> 1], h = r && r.length; n < h; n++) t & 1 ? r[n].call(e) : o = r[n].call(e, o);
  return o;
}, _ = (i, t, e, o, n, r) => {
  var h, a, k, u, A, s = t & 7, C = !!(t & 8), p = !!(t & 16), N = s > 3 ? i.length + 1 : s ? C ? 1 : 2 : 0, z = D[s + 5], K = s > 3 && (i[N - 1] = []), U = i[N] || (i[N] = []), l = s && (!p && !C && (n = n.prototype), s < 5 && (s > 3 || !p) && X(s < 4 ? n : { get [e]() {
    return F(this, r);
  }, set [e](c) {
    return L(this, r, c);
  } }, e));
  s ? p && s < 4 && B(r, (s > 2 ? "set " : s > 1 ? "get " : "") + e) : B(n, e);
  for (var V = o.length - 1; V >= 0; V--)
    u = Y(s, e, k = {}, i[3], U), s && (u.static = C, u.private = p, A = u.access = { has: p ? (c) => tt(n, c) : (c) => e in c }, s ^ 3 && (A.get = p ? (c) => (s ^ 1 ? F : it)(c, n, s ^ 4 ? r : l.get) : (c) => c[e]), s > 2 && (A.set = p ? (c, M) => L(c, n, M, s ^ 4 ? r : l.set) : (c, M) => c[e] = M)), a = (0, o[V])(s ? s < 4 ? p ? r : l[z] : s > 4 ? void 0 : { get: l.get, set: l.set } : n, u), k._ = 1, s ^ 4 || a === void 0 ? f(a) && (s > 4 ? K.unshift(a) : s ? p ? r = a : l[z] = a : n = a) : typeof a != "object" || a === null ? d("Object expected") : (f(h = a.get) && (l.get = h), f(h = a.set) && (l.set = h), f(h = a.init) && K.unshift(h));
  return s || P(i, n), l && I(n, e, l), p ? s ^ 4 ? r : l : n;
}, g = (i, t, e) => q(i, typeof t != "symbol" ? t + "" : t, e), Z = (i, t, e) => t.has(i) || d("Cannot " + e), tt = (i, t) => Object(t) !== t ? d('Cannot use the "in" operator on this value') : i.has(t), F = (i, t, e) => (Z(i, t, "read from private field"), e ? e.call(i) : t.get(i));
var L = (i, t, e, o) => (Z(i, t, "write to private field"), o ? o.call(i, e) : t.set(i, e), e), it = (i, t, e) => (Z(i, t, "access private method"), e);
function x() {
  return (i) => i;
}
var H, j;
H = [x()];
class y {
  constructor(t) {
    g(this, "config");
    g(this, "ChurnZero");
    this.config = t, this.ChurnZero = t.ChurnZero;
  }
  static get providerName() {
    return "churnzero";
  }
  init() {
    this.ChurnZero.push(["setAppKey", this.config.appKey]);
  }
  // start tracking user
  identify(t, e) {
    const {
      global_consumer_id: o,
      organisation_name: n,
      first_name: r,
      last_name: h,
      email: a,
      ...k
    } = e;
    this.ChurnZero.push(["setContact", o.toString(), a]), this.ChurnZero.push(["setAttribute", "Account", "Name", n]), this.ChurnZero.push([
      "setAttribute",
      "Contact",
      {
        FirstName: r,
        LastName: h,
        Email: a,
        ...k
      }
    ]);
  }
  // stop tracking user
  reset() {
    this.ChurnZero.push(["stop"]);
  }
  // track page view
  pageView() {
  }
  // track user event
  trackEvent() {
  }
}
j = m(null), y = _(j, 0, "ChurnZeroProvider", H, y), w(j, 1, y);
var J, O;
J = [x()];
class v {
  constructor(t) {
    g(this, "config");
    this.config = t;
  }
  static get providerName() {
    return "intercom";
  }
  init() {
    window.Intercom("boot", { app_id: this.config.app_id });
  }
  // start tracking user
  identify(t, e = {}) {
    window.Intercom("boot", {
      app_id: this.config.app_id,
      user_id: t,
      ...e
    });
  }
  // stop tracking user
  reset() {
    window.Intercom("shutdown");
  }
  // track page view
  pageView() {
    window.Intercom("update");
  }
  // track user event
  trackEvent(t, e = {}) {
    (!!!this.config.event_allowlist || Array.isArray(this.config.event_allowlist) && this.config.event_allowlist.includes(t)) && window.Intercom("trackEvent", t, e);
  }
}
O = m(null), v = _(O, 0, "IntercomProvider", J, v), w(O, 1, v);
var Q, S;
Q = [x()];
class E {
  constructor(t) {
    g(this, "config");
    g(this, "logrocket");
    this.config = t, this.logrocket = t.logrocket;
  }
  static get providerName() {
    return "logrocket";
  }
  init() {
    this.logrocket.init(this.config.app_id, this.config.options);
  }
  // start tracking user
  identify(t, e = {}) {
    this.logrocket.identify(t, e);
  }
  // stop tracking user
  reset() {
    this.init();
  }
  // track page view
  pageView() {
    this.trackEvent("Page View");
  }
  // track user event
  trackEvent(t, e = {}) {
    this.logrocket.track(t), this.logrocket.captureMessage(t, {
      extra: {
        ...e
      }
    });
  }
}
S = m(null), E = _(S, 0, "LogrocketProvider", Q, E), w(S, 1, E);
var R, $;
R = [x()];
class b {
  constructor(t) {
    g(this, "config");
    g(this, "mixpanel");
    this.config = t, this.mixpanel = t.mixpanel;
  }
  static get providerName() {
    return "mixpanel";
  }
  init() {
    this.mixpanel.init(this.config.token);
  }
  // start tracking user
  identify(t, e) {
    this.mixpanel.identify(t.toString()), this.mixpanel.people.set({
      $first_name: e.first_name,
      $last_name: e.last_name,
      $email: e.email,
      ...e
    });
  }
  // stop tracking user
  reset() {
    this.mixpanel.reset();
  }
  // track page view
  pageView() {
    this.trackEvent("Page View");
  }
  // track user event
  trackEvent(t, e = {}) {
    this.mixpanel.track(t, e);
  }
}
$ = m(null), b = _($, 0, "MixpanelProvider", R, b), w($, 1, b);
const et = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChurnZeroProvider: y,
  IntercomProvider: v,
  LogrocketProvider: E,
  MixpanelProvider: b
}, Symbol.toStringTag, { value: "Module" })), st = (i, t) => (i[t.providerName] = t, i), G = Object.values(et).reduce(st, {});
class ot {
  // setup tracking with plugins
  constructor(t = {}) {
    g(this, "config");
    g(this, "providers");
    this.config = t, this.providers = [], Object.keys(this.config).forEach(
      (e) => this.registerProvider(e, this.config[e])
    );
  }
  // setup an analytics provider
  registerProvider(t, e) {
    G[t] && this.providers.push(new G[t](e));
  }
  init(...t) {
    this.callMethod("init", ...t);
  }
  identify(...t) {
    this.callMethod("identify", ...t);
  }
  reset(...t) {
    this.callMethod("reset", ...t);
  }
  pageView(...t) {
    this.callMethod("pageView", ...t);
  }
  trackEvent(...t) {
    this.callMethod("trackEvent", ...t);
  }
  // calls a method on a provider class for all registered providers
  callMethod(t, ...e) {
    this.providers.forEach((o) => {
      typeof o[t] == "function" && o[t](...e);
    });
  }
}
export {
  ot as default
};
//# sourceMappingURL=analytics-proxy.js.map
